<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Popover from "@shared/svelte/Components/Popover/SimplePopover.svelte";
  import type { CartProduct } from "@shared/types/ProductLine";

  export let product: CartProduct;
  export let saveCallback: any;
  export let show: boolean;

  function close() {
    show = false;
  }

  function prepareDeal() {
    return {
      note: (product.permanent_deal_notes || {}).notes || product.deal_notes,
      original: (product.permanent_deal_notes || {}).notes || product.deal_notes,
      permanent: product.permanent_deal_notes,
    };
  }
  $: deal = prepareDeal();

  function save(_: MouseEvent | null, cb: any | null) {
    if ((product.permanent_deal_notes || {}).notes) {
      product.permanentDeal = true;
    }
    product.deal_notes = deal.note;
    saveCallback(product, cb);
    show = false;
    deal = prepareDeal();
  }

  function savePermanent() {
    product.permanentDeal = true;
    product.permanent_deal_notes = { notes: deal.note };
    save(null, null);
  }

  function removePermanent() {
    if (!(product.permanent_deal_notes || {}).id) {
      return;
    }
    product.removePermanentDeal = true;
    product.deal_notes = "";
    save(null, function () {
      product.permanent_deal_notes = null;
      deal = prepareDeal();
    });
  }

</script>

<Popover bind:show popoverClass={"cart__deal-modal"}>
  <div class="padding--smaller">
    <div class="media">
      <div class="media-fluid">
        <div class="default-body--bold">
          Deal {#if product.product_line}for <span class="notranslate"
              >{product.product_line.name}</span
            >{/if}
        </div>
        <div class="secondary-small--bold margin-bottom--smaller">
          This note will be included on the order for your distributor
        </div>
      </div>
      <Icon
        type="X"
        height="20"
        width="20"
        extraClassNames="media-fixed cursor-pointer margin--smallest close-cart-deal-popover"
        onPress={close}
      />
    </div>
    <div class="input-wrapper full-width textarea margin-bottom--smaller">
      <textarea
        class="input"
        placeholder="Enter the details of your deal or free goods here"
        bind:value={deal.note}
        id="cart-deal-note"
        ng-model="deal.note"
      />
    </div>
    <!-- svelte-ignore a11y-missing-attribute -->
    <div class="media">
      <div class="media-fluid align-left align-self-center">
        {#if !deal.permanent}
          <a
            class="brand-body--bold cursor-pointer save-permanent"
            on:click|preventDefault={savePermanent}>Save Permanently</a
          >
        {/if}
        <div class="default-small--regular">Use this deal note for every order</div>
        {#if deal.permanent}
          <a
            class="default-body--bold color-red cursor-pointer remove-permanent"
            on:click|preventDefault={removePermanent}>Remove Permanent Deal Note</a
          >
        {/if}
      </div>
      <button
        class="button button--primary media-fixed"
        disabled={deal.note == deal.original}
        on:click|preventDefault={() => {
          save(null, null);
        }}>Save</button
      >
    </div>
  </div>
</Popover>
